import { clientV1, clientV2 } from "config/agent";

/**
 * Sets the authorization header on the appropriate client(s)
 * @param {string} token - The bearer token
 * @param {string} clientType - Optional: 'default', 'v2', or 'both'. Defaults to 'both'
 */
export function setAuthHeader(token, clientType = 'both') {
	if (clientType === 'both' || clientType === 'default') {
		clientV1.defaults.headers.common['authorization'] = `Bearer ${token}`;
	}
	if (clientType === 'both' || clientType === 'v2') {
		clientV2.defaults.headers.common['authorization'] = `Bearer ${token}`;
	}
}

/**
 * Clears the authorization header from both clients
 */
export function clearAuthHeader() {
	delete clientV1.defaults.headers.common['authorization'];
	delete clientV2.defaults.headers.common['authorization'];
}

